import { render, staticRenderFns } from "./rankingsIp.vue?vue&type=template&id=7f9e715a&scoped=true&"
import script from "./rankingsIp.vue?vue&type=script&lang=js&"
export * from "./rankingsIp.vue?vue&type=script&lang=js&"
import style0 from "./rankingsIp.vue?vue&type=style&index=0&id=7f9e715a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e715a",
  null
  
)

export default component.exports